import { useEffect, useState } from 'react'

import { Input } from '@skytech/ui'
import { Container } from '@skytech/ui/Container'
import { useDebounce } from '@skytech/utils'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import Tabs from '@/components/Tabs'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import { statusFilterOptions, INJURY_REPORT_STATUS_IDS } from './constants'
import InjuryReportList from './InjuryReportList'

import './index.styles.scss'

const InjuryReportsPage = () => {
  const navigate = useNavigate()
  const translate = useTranslation()

  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')
  const [querySearch, setQuerySearch] = useSearchParamsByKey('search')

  const [searchFilter, setSearchFilter] = useState(querySearch || '')
  const [statusFilter, setStatusFilter] = useState(
    Number(queryStatus) || INJURY_REPORT_STATUS_IDS.PENDING_MANAGER
  )

  const debouncedSearchTerm = useDebounce(searchFilter, 500)
  const tabs = statusFilterOptions.map(option => ({
    value: option.value,
    label: <Translation id={`injury_report_status/${option.label}`} />,
  }))

  useEffect(() => {
    setSearchFilter(querySearch || '')
    setStatusFilter(Number(queryStatus) || INJURY_REPORT_STATUS_IDS.PENDING_MANAGER)
  }, [querySearch, queryStatus])

  useEffect(() => {
    setQuerySearch(debouncedSearchTerm)
  }, [debouncedSearchTerm, setQuerySearch])

  return (
    <Container onSwipedLeft={() => navigate('/')} className="injury-report-list">
      <Container.Header>
        <Translation id="Damage Reports" />
      </Container.Header>

      <div className="status-filter">
        <div className="status-filter__status">
          <Tabs
            tabs={tabs}
            selectedValue={statusFilter}
            onClick={statusId => {
              setStatusFilter(Number(statusId))
              setQueryStatus(statusId)
            }}
          />
        </div>

        <div className="status-filter__text-filter">
          <Input
            id="searchFilter"
            type="text"
            value={searchFilter}
            placeholder={translate('Search')}
            onChange={e => {
              const text = e.target.value
              setSearchFilter(text)
            }}
          />
        </div>
      </div>

      <InjuryReportList searchFilter={searchFilter} statusFilter={statusFilter} />
    </Container>
  )
}

export default InjuryReportsPage
